module.exports = __webpack_public_path__ + "img/Nl-Studio.b2970f7c.gif";